// Illustrative deal structures — educational walkthroughs of how a working
// commercial finance broker would approach common file types. Every scenario
// is a fictionalized illustrative example, not a specific closed transaction.
// See /app/frontend/src/components/site/IllustrativeDisclaimer.jsx for the
// standing disclaimer shown on every page.
//
// Add a new deal structure by dropping a file in this folder and importing
// it below. Each meta.tags entry should match one of the FILTER_TAGS ids
// in /app/frontend/src/pages/CaseStudies.jsx.

import hvacContractor185k from "./hvac-contractor-185k-summer-crunch";
import sbaAcquisition from "./sba-acquisition-680k-multi-location-laundromat";
import equipmentLoan from "./equipment-loan-865k-refrigerated-trucking-fleet";
import badCreditRestaurant from "./bad-credit-restaurant-revenue-financing-95k";
import realEstateBridge from "./real-estate-bridge-720k-atlanta-fix-and-flip";
import realEstateDscr from "./real-estate-dscr-980k-4unit-multifamily-refinance";
import wcFranchise from "./working-capital-franchise-310k-holiday-inventory";
import badCreditAutoRepair from "./bad-credit-auto-repair-65k-tax-lien-recovery";
import badCreditEcommerce from "./bad-credit-ecommerce-220k-holiday-inventory-620-fico";

const studies = [
  hvacContractor185k,
  sbaAcquisition,
  equipmentLoan,
  badCreditRestaurant,
  realEstateBridge,
  realEstateDscr,
  wcFranchise,
  badCreditAutoRepair,
  badCreditEcommerce,
];

export const getAllCaseStudies = () =>
  studies
    .map((s) => s.meta)
    .sort((a, b) => new Date(b.date) - new Date(a.date));

export const getCaseStudyBySlug = (slug) =>
  studies.find((s) => s.meta.slug === slug) || null;

// Given a blog article slug, return the FIRST case study that lists it in its
// relatedArticles array. Used by BlogPost.jsx to show a contextual teaser.
export const getCaseStudyForArticle = (articleSlug) => {
  if (!articleSlug) return null;
  const match = studies.find((s) =>
    (s.meta.relatedArticles || []).includes(articleSlug)
  );
  return match ? match.meta : null;
};
